import * as tslib_1 from "tslib";
import { Component } from "vue-property-decorator";
import SmartLocation from "@cloudpivot/form/src/common/components/smart-location/index.vue";
import { FormLocationControl } from "@cloudpivot/form/src/common/controls/form-location-control";
import { FromAddressValueService } from "@cloudpivot/form/src/common/services";
let InputLocation = class InputLocation extends FormLocationControl {
    get initMap() {
        console.log(FormLocationControl.service);
        return FormLocationControl.service.initMap;
    }
    valueChange(val) {
        if (val.adcode) {
            FromAddressValueService.setAddressVal(val.adcode).then((value) => {
                // this.ctrl.value = Object.assign(this.val,value);
                this.setValue(Object.assign(this.val, value));
            });
        }
        else {
            this.ctrl.value = null;
        }
    }
};
InputLocation = tslib_1.__decorate([
    Component({
        name: "input-location",
        components: {
            SmartLocation
        }
    })
], InputLocation);
export default InputLocation;
